import { render, staticRenderFns } from "./float-btn.vue?vue&type=template&id=02204a97&scoped=true"
import script from "./float-btn.vue?vue&type=script&lang=js"
export * from "./float-btn.vue?vue&type=script&lang=js"
import style0 from "./float-btn.vue?vue&type=style&index=0&id=02204a97&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02204a97",
  null
  
)

export default component.exports